import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  MAP_TOGGLE_SIDEBAR,
  MAP_SET_SITE_PICK_MODE,
  MAP_SET_PLACE_MODE,
} from 'redux/actions';

const AppHeader = () => {
  const dispatch = useDispatch();
  const { sidebar_open, site_pick_mode, place_mode, selection_mode } = useSelector((s) => s.map);

  const mapActionLabel = site_pick_mode
    ? 'Tap map to set site location'
    : place_mode
      ? 'Tap map to place tree'
      : selection_mode
        ? 'Select trees on the map'
        : null;

  const handleCancelMapAction = () => {
    if (site_pick_mode) {
      dispatch(MAP_SET_SITE_PICK_MODE.requestAction({ enabled: false }));
      return;
    }
    if (place_mode) {
      dispatch(MAP_SET_PLACE_MODE.requestAction({ enabled: false }));
    }
  };

  return (
    <header className="app-header">
      <button
        type="button"
        className="btn-header-menu"
        onClick={() => dispatch(MAP_TOGGLE_SIDEBAR.requestAction())}
        aria-label={sidebar_open ? 'Hide menu' : 'Show menu'}
      >
        {sidebar_open ? '‹' : '☰'}
      </button>

      <div className="app-header-title">
        <h1>Tree Survey</h1>
        {mapActionLabel && (
          <p className="app-header-hint">{mapActionLabel}</p>
        )}
      </div>

      {(site_pick_mode || place_mode) && (
        <button
          type="button"
          className="btn btn-secondary btn-header-cancel"
          onClick={handleCancelMapAction}
        >
          Cancel
        </button>
      )}
    </header>
  );
};

export default AppHeader;
